import React from 'react';
import { Button } from '../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Robot, CaretDown } from '@phosphor-icons/react';

/**
 * Ask Agent button with dropdown prompts
 * Used in module pages to provide context-specific agent actions
 */
export const AskAgentButton = ({ prompts, onPromptSelect, variant = 'outline', size = 'sm' }) => {
  if (!prompts || prompts.length === 0) {
    return null;
  }

  if (prompts.length === 1) {
    return (
      <Button
        variant={variant}
        size={size}
        onClick={() => onPromptSelect(prompts[0].prompt, prompts[0].context)}
        className="gap-1.5"
        data-testid="ask-agent-btn"
      >
        <Robot size={14} weight="duotone" />
        {prompts[0].label}
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className="gap-1.5" data-testid="ask-agent-btn">
          <Robot size={14} weight="duotone" />
          Ask Agent
          <CaretDown size={12} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {prompts.map((p, i) => (
          <DropdownMenuItem
            key={i}
            onClick={() => onPromptSelect(p.prompt, p.context)}
            data-testid={`ask-agent-option-${i}`}
          >
            {p.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AskAgentButton;
